import axios from "axios";
import authHeader from "./auth-header";

const serveradr = require('./IPadr.js').serveradr;

//*******************************************************************
//tohle prepsat *****************************************************
// const API_URL = "http://server.ipmdevelop.cz/api/test/";
const API_URL = "http://"+ serveradr + "/api/test/";


const getPublicContent = () => {
    return axios.get(API_URL + "all");
};

const getUserBoard = () => {
    return axios.get(API_URL + "user", { headers: authHeader() });
};

const getDeviceContent = (id) => {
    if (id === undefined) return axios.get(API_URL + "device_content", { headers: authHeader() });
    else return axios.get(API_URL + "device_content?dev=" + id.dbid, { headers: authHeader() });
};


const getAdminBoard = () => {
    return axios.get(API_URL + "admin", { headers: authHeader() });
};

const getAdminBoard_all = () => {
    return axios.get(API_URL + "admin_all", { headers: authHeader() });
};

const getAdminBoard_uw = () => {
    return axios.get(API_URL + "admin_uw", { headers: authHeader() });
};

const getAdminBoard_ug = () => {
    return axios.get(API_URL + "admin_ug", { headers: authHeader() });
};

const getAdminBoard_users = () => {
    return axios.get(API_URL + "admin_users", { headers: authHeader() });
};

const getDeleteUser = (user, dev) => {
    return axios.get(API_URL + "delete_user?user=" + user + "&dev=" + dev, { headers: authHeader() });
};

const getAddDeviceToUser = (user, dev) => {
    return axios.get(API_URL + "add_device_to_user?user=" + user + "&dev=" + dev, { headers: authHeader() });
};


export default {
    getPublicContent,
    getUserBoard,
    getAdminBoard,
    getAdminBoard_all,
    getAdminBoard_uw,
    getAdminBoard_ug,
    getAdminBoard_users,
    getDeviceContent,
    getDeleteUser,
    getAddDeviceToUser
};
